import React from 'react';
import '../styles/ThankYou.css'; // Reusing same styling

const Failed = () => {
  return (
    <div className="thankyou-container">
      <h1>❌ Payment Failed</h1>
      <p>Sorry, your payment could not be processed.</p>
      <p>Please try again or contact support.</p>
      <a href="/" className="back-home">Go to Home</a>
    </div>
  );
};

export default Failed;
